module.exports = __webpack_public_path__ + "img/clock_alert.694475e9.svg";